var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_vm._v("Call ended")]),_c('v-card-text',[_vm._v(" Thank you! ")]),_c('v-card-actions')],1)}
var staticRenderFns = []

export { render, staticRenderFns }